<script>
  import Gallery from 'src/pc/pages/Gallery'
  import PageLayout from '../layouts/PageLayout'
  import SubPageLayout from '../layouts/SubPageLayout'
  import DisplayContainer from '../components/DisplayContainer'
  export default {
    extends: Gallery,
    components: {
      PageLayout,
      PageLayout,
      SubPageLayout,
      DisplayContainer
    },
    computed: {
      getAccess() {
        return 'mobile'
      }
    }
  }
</script>

<style>
  .gallery {
    top: 0 !important;
  }
  .gallery .title {
    width: 100vw;
    height: 100px;
    margin-bottom: 30px !important;
  }
  .gallery .title_top {
    width: 100vw;
    height: 100px;
    padding: 20px;
    justify-content: center;
  }
  .gallery .title_top:before {
    width: 28px;
    height: 30px;
    margin-right: 8px;
  }
  .gallery .title_top p {
    font-size: 34px;
  }
	.gallery .gallery_sch {
		text-align: left;
	}
	.gallery .gallery_sch .sch_box {
		width: 80%;
	}
	.gallery .gallery_sch .sch_box input {
		width: calc(100% - 70px);
		font-size: 14px;
	}
	.gallery .gallery_sch .sch_btn {
		width: 70px;
		font-size: 13px;
		line-height: 38px;
		padding: 0;
	}
	.gallery .gallery_sch .reset {
		width: 18%;
		font-size: 13px;
		line-height: 38px;
		padding: 0;
	}
	.gallery .list_gallery {
		width: 100vw;
		margin-left: -15px;
	}
	.gallery .list_gallery ul {
		width: 100vw;
    height: 80vw;
	}
	.gallery .list_gallery li .subj {
		padding: 40px 15px 10px 15px;
	}
	.gallery .list_gallery li .subj h5 {
		font-size: 18px;
		line-height: 1.4em;
	}
	.gallery .list_gallery li .subj h6 {
		font-size: 13px;
	}
	.gallery .list_gallery ul:nth-child(5n) {
		margin-bottom: 200px;
	}
	.gallery .list_gallery ul:nth-child(10n+1),
  .gallery .list_gallery ul:nth-child(10n+7) {
		width: 100vw;
	}
	.gallery .list_gallery ul .ad_list {
		margin-top: -100px;
	}
	.gallery .list_gallery ul .ad_list a img {
		width: 300px !important;
    height: auto !important;
	}
</style>
